import { useEffect, useState } from 'react';

/**
 * Tracks the keyboard height offset using the Visual Viewport API.
 * Returns a pixel value representing how much the keyboard has pushed up the viewport.
 */
export function useKeyboardOffset(): number {
  const [keyboardOffset, setKeyboardOffset] = useState(0);

  useEffect(() => {
    const viewport = window.visualViewport;
    if (!viewport) return;

    const handleResize = () => {
      const heightDiff =
        window.innerHeight - viewport.height - viewport.offsetTop;
      setKeyboardOffset(heightDiff > 0 ? heightDiff : 0);
    };

    viewport.addEventListener('resize', handleResize);
    viewport.addEventListener('scroll', handleResize);
    handleResize();

    return () => {
      viewport.removeEventListener('resize', handleResize);
      viewport.removeEventListener('scroll', handleResize);
    };
  }, []);

  return keyboardOffset;
}
